package pl.mothdigital.neuronowi.components.widgets

import androidx.compose.runtime.*
import com.varabyte.kobweb.compose.ui.*
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.components.icons.*
import com.varabyte.kobweb.silk.style.*
import pl.mothdigital.neuronowi.theme.*

val HamburgerButtonStyle = CssStyle.base {
    Modifier.color(SiteTheme.black._900)
}

@Composable
fun HamburgerButton(onClick: () -> Unit) {
    IconButton(onClick) {
        HamburgerIcon(modifier = HamburgerButtonStyle.toModifier().ariaLabel("Otwórz menu nawigacji"))
    }
}
